import { camelCase, isNil } from 'lodash';
import React, { Component } from 'react';

export default class TextareaInput extends Component<any> {
    render() {
        const { title, value, handleChange, className } = this.props;
        return (
            <div className={`form__field ${className}`}>
                <label htmlFor={camelCase(title)}>{title}</label>
                <textarea
                    id={camelCase(title)}
                    name={camelCase(title)}
                    value={value}
                    onChange={(e) => handleChange(camelCase(title), e.target.value)}
                    readOnly={isNil(this.props.isReadOnly) ? false : this.props.isReadOnly}
                    placeholder={this.props.placeholderText ?? ''}
                />
            </div>
        );
    }
}
